import { createSelector } from 'reselect'

export const selectAppSettings = (store) => store.appSettings

export const selectAllAppSettings = createSelector([selectAppSettings], (appSettings) => appSettings)
export const selectAppSettingsError = createSelector([selectAppSettings], (appSettings) => appSettings?.error)